import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { FACTOR_SENSITIVITY_CONTEXT } from "./context"

export default function FactorSensitivityHeader({ modelMetadata, context, flattenedMetrics, onMetricsChange }) {
  const factorSensitivityContext = useContext(FACTOR_SENSITIVITY_CONTEXT)
  const { selectedMetricDisplay, setSelectedMetricDisplay, selectedCategory, setSelectedCategory } = factorSensitivityContext
  const { view } = useContext(context)

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const metricOptions = useMemo(
    () => ({ prefix: view, selectedCategory, selectedMetricDisplay }),
    [view, selectedCategory, selectedMetricDisplay],
  )

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions })

  const displayOptions = useMemo(() => METRIC_OPTIONS.factorSensitivity.map(({ id, label, isDefault, secondaryText, tooltip }) => ({ id, primaryText: label, isDefault, secondaryText, tooltip })), [])

  const categoryOptions = useMemo(() => modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })), [modelMetadata])

  return <>
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

FactorSensitivityHeader.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
  context: PropTypes.object.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
}
